import LegalLanguagePopUp, {
  LegalLanguagePopUpProps,
} from './LegalLanguagePopUp';

export type {LegalLanguagePopUpProps};
export default LegalLanguagePopUp;
